import { render, staticRenderFns } from "./GalleryBlock.vue?vue&type=template&id=4bac4e5c&scoped=true&"
import script from "./GalleryBlock.vue?vue&type=script&lang=js&"
export * from "./GalleryBlock.vue?vue&type=script&lang=js&"
import style0 from "./styles/GalleryBlock.scss?vue&type=style&index=0&id=4bac4e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac4e5c",
  null
  
)

export default component.exports